export const FOUNDER = {
  id: 'founder',
  name: 'Founder'
}
export const CEO = {
  id: 'ceo',
  name: 'CEO'
}
export const HEADOFDIVISION = {
  id: 'headofdivision',
  name: 'Head of Division'
}
export const EMPLOYEE = {
  id: 'employee',
  name: 'Employee'
}
export const EXECUTIVE = {
  id: 'executive',
  name: 'Executive'
}
export const HEADOFDEPARTMENT = {
  id: 'headofdepartment',
  name: 'Head of Department'
}
export const HEADOFSECTION = {
  id: 'headofsection',
  name: 'Head of Section'
}

export const HR = {
  id: 'hr',
  name: 'HR'
}

export const ACCOUNTANT = {
  id: 'accountant',
  name: 'accountant'
}

export const CRM_ENTRY_USER = {
  id: 'crmEntryUser',
  name: 'CRM Entry User'
}
export const CRM_SUPER_USER = {
  id: 'superEntryUser',
  name: 'CRM Super User'
}
export const ROLES_LIST = [FOUNDER, CEO, EXECUTIVE, HEADOFDIVISION, HEADOFDEPARTMENT,
  HEADOFSECTION, EMPLOYEE, HR, ACCOUNTANT, CRM_ENTRY_USER, CRM_SUPER_USER]



// WEBPACK FOOTER //
// ./src/constants/roles.js